import {
    GET_BERGEN_BILLING_REQUEST,
    GET_BERGEN_BILLING_SUCCESS,
    GET_BERGEN_BILLING_ERROR,
    ADD_BERGEN_BILLING_ERROR,
    ADD_BERGEN_BILLING_REQUEST,
    ADD_BERGEN_BILLING_SUCCESS,
    UPDATE_BERGEN_BILLING_SUCCESS,
    UPDATE_BERGEN_BILLING_ERROR,
    UPDATE_BERGEN_BILLING_REQUEST,
    DELETE_BERGEN_BILLING_ERROR,
    DELETE_BERGEN_BILLING_REQUEST,
    DELETE_BERGEN_BILLING_SUCCESS

} from "./types"
import axios from "axios";
import { BASEURL } from "../../constant/config.js"



export const loadBergenBillingOption = (token) => dispatch => {
    dispatch({ type: GET_BERGEN_BILLING_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/adminBerganBilling`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_BERGEN_BILLING_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_BERGEN_BILLING_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_BERGEN_BILLING_ERROR,
                payload: error.response,
            });
        })
};

export const addBerganBilling = (token, data, id) => (dispatch) => {
    dispatch({ type: ADD_BERGEN_BILLING_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/adminBerganBilling`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {

            return dispatch({ type: ADD_BERGEN_BILLING_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_BERGEN_BILLING_ERROR,
                payload: error.response,
            });
        });
};




export const updateBerganBilling = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_BERGEN_BILLING_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/adminBerganBilling/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {

            return dispatch({ type: UPDATE_BERGEN_BILLING_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_BERGEN_BILLING_ERROR,
                payload: error.response,
            });
        });
};



export const deleteBerganBilling = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_BERGEN_BILLING_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/adminBerganBilling/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_BERGEN_BILLING_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_BERGEN_BILLING_ERROR,
                payload: error.response,
            });
        });
};

